<script setup>
import Star from '@/components/Star';
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  btnType: {
    type: String,
    default: 'loading',
  },
});

const store = useStore();
const info = computed(() => store.state.appInfo);

const emit = defineEmits(['confirm', 'play']);

const handleConfirm = () => {
  emit('confirm');
};
const handlePlay = () => {
  emit('play');
};
</script>
<template>
  <div class="ios-main-top">
    <div class="main-up">
      <div class="logo">
        <div
          class="loading-logo"
          v-if="btnType === 'installing'">
          <div class="loader"></div>
          <img :src="info.icon" />
        </div>
        <img
          :src="info.icon"
          v-else />
      </div>
      <div class="info">
        <h1>{{ info.name }}</h1>
        <h2>{{ info.author }}</h2>
        <!-- <p>{{ info.language_list.basic_info.verified }}</p> -->
        <div
          class="btn btn-h"
          v-if="btnType === 'install'"
          @click="handleConfirm">
          <div>
            {{ info.language_list.get }}
          </div>
        </div>
        <div
          v-else
          @click="handlePlay"
          class="btn btn-h">
          {{ info.language_list.get }}
        </div>
      </div>
      <div
        class="iconfont icon-icon-"
        @click="handleConfirm"></div>
    </div>
    <ul class="information">
      <li>
        <p>{{ info.comment }}{{ info.language_list.ratings }}</p>
        <strong> {{ info.score }}</strong>
        <p>
          <Star
            :score="info.score"
            class="info-star"></Star>
        </p>
      </li>
      <li>
        <p>{{ info.language_list.age }}</p>
        <strong>{{ info.ages }}</strong>
        <p>{{ info.language_list.years }}</p>
      </li>
      <li>
        <p>{{ info.language_list.chart }}</p>
        <strong>#1</strong>
        <p>Game</p>
      </li>
      <li>
        <p>{{ info.language_list.developer }}</p>
        <i class="iconfont icon-a-Group885"></i>
        <p>{{ info.author }}</p>
      </li>
    </ul>
    <div class="banner-imgs-box">
      <ul class="banner-imgs">
        <li
          v-for="(item, index) in info.banner"
          :key="index"
          @click="handleConfirm">
          <img
            :src="item.src"
            alt="" />
        </li>
      </ul>
    </div>
    <div class="deviced flex justify-between align-center">
      <div class="flex align-center">
        <i class="icon iphone"></i>
        <i class="icon ipad"></i>
        <span>iphone、ipad</span>
      </div>
      <i class="iconfont icon-xiajiantou"></i>
    </div>
  </div>
</template>
<style lang="scss">
.ios-main-top {
  padding-top: 20px;
  .star-rating {
    font-size: 12px;
    .star {
      width: 12px;
    }
    .full-star,
    .half-star {
      color: #666 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.ios-main-top {
  min-height: 205px;
  padding-top: 220px;
  .main-up {
    display: flex;
    align-items: center;
    position: relative;
    .info {
      h1 {
        color: #000000;
        font-weight: normal;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
      }
      h2 {
        margin: 12px 0;
        color: #666;
        font-size: 12px;
      }
      p {
        font-size: 12px;
      }
    }
    .icon-icon- {
      position: absolute;
      right: 20px;
      bottom: 0;
    }
  }
  .logo {
    width: 96px;
    height: 96px;
    margin-right: 24px;
    border-radius: 20%;
    img {
      display: block;
      width: 100%;
      border-radius: 20%;
      box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3),
        0 1px 3px 1px rgba(60, 64, 67, 0.15);
    }
  }
  .information {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 100%;
    border-top: 1px solid #ddd;
    padding-top: 8px;
    color: #999;
    strong {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      color: #666;
      margin: 4px 0;
    }
    p {
      font-size: 12px;
    }
    li {
      position: relative;
      flex: 1;
      text-align: center;
      &:before {
        background-color: #ddd;
        content: '';
        display: block;
        height: 24px;
        left: 0;
        position: absolute;
        top: calc(50% - 12px);
        width: 1px;
      }
    }
    & > :first-child:before {
      display: none;
    }
    .icon-a-Group885 {
      color: #666;
    }
  }
  .banner-imgs-box {
    overflow-x: auto;
    overflow-y: hidden;
    margin: 20px 0;
    .banner-imgs {
      display: flex;
      flex-wrap: nowrap;
      width: fit-content;
      height: 224px;
    }
    .banner-imgs li {
      border-radius: 8px;
      height: 224px;
      margin-right: 11px;
      overflow: hidden;
    }
    .banner-imgs li img {
      display: block;
      height: 100%;
    }
  }
  .deviced {
    width: 100%;
    .icon {
      width: 16px;
      height: 16px;
      display: inline-block;
      margin: 0 1px;
    }
    .ipad {
      margin-right: 5px;
    }

    .iphone {
      background: url(~@/assets/images/iphone.png) no-repeat center;
      background-size: 100%;
    }
    .ipad {
      background: url(~@/assets/images/ipad.png) no-repeat center;
      background-size: 100%;
    }
    .icon-xiajiantou {
      color: #666;
    }
  }
}
</style>
